module.exports = __webpack_public_path__ + "img/whiteBlueDown.35cbd0c6.svg";